// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const ModalHeader = props =>
    <header>
        <span>
            <FormattedMessage id={props.id}/>
        </span>
        <span
            className='close-modal-icon'
            onClick={props.onModalClose}
        />
    </header>;

ModalHeader.displayName = 'ModalHeader';
ModalHeader.propTypes = {
    id: PropTypes.string.isRequired,
    onModalClose: PropTypes.func.isRequired
};

export default ModalHeader;



// WEBPACK FOOTER //
// ./src/shared/components/modal/modal-header.js